import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, Inject, OnInit, Optional, PLATFORM_ID, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { ChatService } from '@app/services/chat.service';
import { GlobalcontentService } from '@app/services/globalcontent.service';
import { fromEvent } from 'rxjs';
import { MediaService } from '@app/services/media.service';
import { MEDIA_TOKEN } from '../../../../tockens';

@Component({
    selector: 'clever-overmenu',
    imports: [
        MatIconModule
    ],
    templateUrl: './overmenu.component.html',
    styleUrl: './overmenu.component.scss'
})
export class OvermenuComponent implements OnInit {
    isBrowser: boolean = false;
    destroyRef = inject(DestroyRef);
    showbtns = signal<boolean>(false);
    lastposition: number = 0;
    partner: Partner;

    anfpath = signal<string>('');
    contpath = signal<string>('');
    whatsapp = signal<string>('');
    showchat = signal<boolean>(false);
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected authguard: AuthGuardService,
        protected chatService: ChatService,
        protected mediaService: MediaService,
        protected gservice: GlobalcontentService,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.checkPartner();
            this.initScroll();
        }
    }

    async checkPartner() {
        this.authguard.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((pp) => {
            if (pp?.partnerid?.length > 0) {
                this.partner = pp;
                this.showchat.set(!pp.hideChat);
                this.chekcAnfrageContact();
                if (pp.telaswhatsapp) {
                    this.whatsapp.set(pp.tel);
                } else if(pp.mobileaswhatsapp) {
                    this.whatsapp.set(pp.mobile);
                }
            }
        });
    }

    async openChat() {
        this.chatService.setOpenChat();
    }

    async chekcAnfrageContact() {
        this.gservice.request({ partnerid: this.partner.partnerid }, 'checkanfragecontact').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((res) => {
            if (res?.anfrage?.path) {
                if (res.anfrage.path !== '/') {
                    this.anfpath.set(res.anfrage.path + '/' + res.anfrage.pathname);
                } else {
                    this.anfpath.set('/' + res.anfrage.pathname);
                }
            }
            if (res?.contact?.path) {
                if (res.contact.path !== '/') {
                    this.contpath.set(res.contact.path + '/' + res.contact.pathname);
                } else {
                    this.contpath.set('/' + res.contact.pathname);
                }
            }
        });
    }

    async initScroll() {
        fromEvent(window, 'scroll').pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((e) => {
            this.lastposition = window.scrollY;
            this.checkScrollPos();
        });
    }

    checkScrollPos(): void {
        // faire quelque chose avec la position du scroll
        if (this.lastposition >= 550) {
            this.showbtns.set(true);
        } else {
            this.showbtns.set(false);
        }
    }
}
